function _getCookie(name) {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

function _setCookie(name, value) {
  document.cookie = `${name}=${value}; path=/`
}
document.addEventListener("DOMContentLoaded", () => {
  const discountCodeApply = _getCookie('discount_code_apply');
  
  if (!discountCodeApply) {
    _setCookie('discount_code_apply', '');
  }

  const discountCode = _getCookie('discount_code');

  if (discountCode) {
    if (discountCode !== discountCodeApply) {
      _setCookie('discount_code_apply', discountCode);
      const popup = document.querySelector('.js-popup-apply-discount');
      // Mostrar con efecto fadeIn
      popup.style.opacity = 0;
      popup.style.display = 'flex';

      let fade = 0;
      const fadeInInterval = setInterval(() => {
        fade += 0.05;
        if (fade >= 1) {
          fade = 1;
          clearInterval(fadeInInterval);
        }
        popup.style.opacity = fade;
      }, 25); // 500ms total (0.05 * 20 steps = 1)

      setTimeout(() => {
        popup.style.display = 'none';
      }, 5100);

    }
  }

  document.querySelector('.js-popup-apply-discount__close').addEventListener('click', function () {
    document.querySelector('.js-popup-apply-discount').style.display = 'none';
  });

})
